import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { ReactComponent as CloseIcon } from '../../../shared/icons/close-icon.svg';
import { CancelApprovalButton } from './components/headerActions/requestReview/CancelApprovalButton';
import { InternalApprovalBadgeContainer } from './components/headerActions/requestReview/InternalApprovalBadgeContainer';
import { ApprovalRequestThreshold } from './components/headerActions/requestReview/RequestInternalApprovalModalConstants';
import SendInternalReminderModal from './components/headerActions/sendInternalReminder/sendInternalReminderModal';
import './mobile-creator-pending-header.scss';

interface MobileCreatorPendingHeaderProps {
  onClose?: () => void;
  title: string;
  documentId: string;
  dealId: string;
  teamId: string;
  requestId: string;
  approvalRequest?: any; // Need this to pass the reviews and threshold
}

export const MobileCreatorPendingHeader: React.FC<MobileCreatorPendingHeaderProps> = ({
  onClose,
  title,
  documentId,
  dealId,
  teamId,
  requestId,
  approvalRequest,
}) => {
  const [showReminderModal, setShowReminderModal] = useState(false);

  const handleCloseClick = () => {
    onClose?.();
  };

  return (
    <header className="mobile-creator-pending-header" data-testid="mobile-creator-pending-header">
      {/* First row: Close button, centered title, cancel button */}
      <div className="mobile-creator-pending-header__main-row">
        <button
          type="button"
          onClick={handleCloseClick}
          className="mobile-creator-pending-header__close-btn"
          data-testid="mobile-creator-pending-header__close"
          aria-label="Close document"
        >
          <CloseIcon className="mobile-creator-pending-header__close-icon" />
        </button>

        <h1 className="mobile-creator-pending-header__title" title={title}>
          {title}
        </h1>

        <div className="mobile-creator-pending-header__buttons" style={{ display: 'flex', gap: '0.5rem' }}>
          <Button
            variant="primary"
            size="sm"
            onClick={() => setShowReminderModal(true)}
          >
            Send Reminder
          </Button>
          <CancelApprovalButton
            documentId={documentId}
            dealId={dealId}
            teamId={teamId}
            requestId={requestId}
            className="btn-sm"
            buttonText="Cancel Request"
          />
        </div>
      </div>

      {/* Second row: Internal approval pending badge */}
      <div className="mobile-creator-pending-header__badge-row">
        <InternalApprovalBadgeContainer
          documentId={documentId}
          dealId={dealId}
          requestId={requestId}
          teamId={teamId}
          approvalRequestedReviews={approvalRequest?.reviews}
          isOneConfirmationRequired={approvalRequest?.threshold === ApprovalRequestThreshold.ONE}
          useApprovalOrder={Boolean(approvalRequest?.useApprovalOrder)}
          currentApproverId={approvalRequest?.currentApprover?.id}
          isCreator={false}
        />
      </div>

      {/* Send Reminder Modal */}
      <SendInternalReminderModal
        show={showReminderModal}
        onHide={() => setShowReminderModal(false)}
        documentId={documentId}
        approvalRequestId={requestId}
        reviewers={
          approvalRequest?.useApprovalOrder && approvalRequest?.currentApprover
            ? [] // For sequential approval, we only use currentReviewer
            : approvalRequest?.reviews?.filter((r: any) => !r.approvedAt && !r.rejectedAt).map((r: any) => ({
                id: r.reviewer.id,
                fullName: r.reviewer.fullName,
                email: r.reviewer.email
              }))
        }
        useApprovalOrder={approvalRequest?.useApprovalOrder}
        currentReviewer={approvalRequest?.currentApprover ? {
          fullName: approvalRequest.currentApprover.fullName,
          email: approvalRequest.currentApprover.email
        } : undefined}
      />
    </header>
  );
};
